import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MaisonsComponent } from 'projects/hp-api/src/lib/maisons/maisons.component';
import { FinaliserComponent } from 'projects/hp-api/src/lib/finaliser/finaliser.component';
import { FamillesChildComponent } from 'projects/hp-api/src/lib/familles-child/familles-child.component';
import { ProduitsComponent } from 'projects/hp-api/src/lib/produits/produits.component';
import { SelecteurPorteComponent } from 'projects/hp-api/src/lib/selecteur-porte/selecteur-porte.component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';


const routes: Routes = [

  { path: 'simuleo-hp', component: MaisonsComponent  },
  { path: 'selecteur-de-portes', component: SelecteurPorteComponent  },
  { path: 'sous-familles', component: FamillesChildComponent  },
  { path: 'liste-produits', component: ProduitsComponent  },
 
  { path: 'simulateur-de-portes', component: SimulateurComponent },
  { path: 'simulateur-finalisation', component: FinaliserComponent  },
  { path: '',   redirectTo: 'simuleo-hp', pathMatch: 'full'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppBaseRoutingModule { }
